/* eslint-disable valid-jsdoc */
import _ from 'underscore';
import { Message } from 'botframework-directlinejs';
import { type TCreateStructuredLogBase } from '../types/structured-log-types';

/**
 * `createStructuredLogBase` is a utility function that creates a structured log base object
 * @param params - parameters to create a structured log base object
 * @returns structured log base object
 */
export const createStructuredLogBase: TCreateStructuredLogBase = (params) => {
  const { activity } = params;

  return {
    activityId: activity.id as string,
    activityType: 'Unknown',
    activityText: (activity as Message).text as string,
    activityUsername: activity.from?.name as string,
    replyToId: activity.replyToId as string,
    conversationId: activity?.conversation?.id,
    additionalContext: {
      ...activity.value?.AdditionalContext,
      ..._.omit(activity.value?.UxContext, 'AUTH_CCSmallToken'),
    },
  };
};
